import { Button, Text, Flex } from "@radix-ui/themes";
import CopyCSVToClipboard from "./copy-csv-to-clipboard";
import { AssigneeCombobox } from "./assignee-combobox";
import { RowSelectionState } from "@tanstack/react-table";
import { Order } from "@/shared/api/lod-api";

interface AssignmentActionsProps {
  rowSelection: RowSelectionState;
  tableData: Order[];
  selectedAssignee: string | undefined;
  setSelectedAssignee: (value: string | undefined) => void;
  handleAssign: () => void;
  loading: boolean;
  selectedOrdersCSV: string;
}

const AssignmentActions = ({
  rowSelection,
  tableData,
  selectedAssignee,
  setSelectedAssignee,
  handleAssign,
  loading,
  selectedOrdersCSV,
}: AssignmentActionsProps) => {
  return (
    <Flex
      align="center"
      gap="2"
      className="flex-1 bg-brand-gray-25 border-t border-brand-gray-100"
      p="1"
    >
      <Text size="2">Assign to</Text>
      <AssigneeCombobox
        disabled={Object.keys(rowSelection).length === 0}
        onValueChange={(value) => setSelectedAssignee(value)}
      />
      <Button
        radius="full"
        size="1"
        variant="outline"
        onClick={handleAssign}
        loading={loading}
        disabled={
          selectedAssignee === undefined ||
          loading ||
          Object.keys(rowSelection).length === 0
        }
      >
        Assign
      </Button>
      <Text size="2">
        {Object.keys(rowSelection).length} of {tableData.length} selected
      </Text>
      <CopyCSVToClipboard
        value={selectedOrdersCSV}
        disabled={Object.keys(rowSelection).length === 0}
      />
    </Flex>
  );
};

export default AssignmentActions;
